import React from "react";

import RepeatIcon from "@mui/icons-material/Repeat";
import { Box, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  addDays,
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  getDay,
  startOfMonth,
  startOfWeek,
} from "date-fns";
import { withStyles } from "tss-react/mui";

import CalendarIntervals from "../components/CalendarIntervals";

const StyledTableCell = withStyles(TableCell, {
  root: {
    borderRight: "1px solid #DEE6F0",
    backgroundColor: "#fff",
  },
});

const StyledRepeatIcon = withStyles(RepeatIcon, {
  root: {
    height: 14,
    width: 14,
  },
});

const CalendarView: React.FC = () => {
  const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  function getMonthDaysByWeeks() {
    const startDate = startOfMonth(new Date());
    const endDate = endOfMonth(startDate);
    const endWeek = endOfWeek(endDate);

    const firstDayColumn = getDay(startDate);

    let currentDay = startOfWeek(startDate);
    const weeks = [];

    while (currentDay <= endWeek) {
      const daysInWeek = eachDayOfInterval({
        start: currentDay,
        end: addDays(currentDay, 6),
      });

      const daysWithEmptyCells = [];

      if (getDay(currentDay) !== firstDayColumn) {
        // Add empty cells until the first day of the month aligns with the correct column
        const emptyCellsCount = getDay(currentDay) - firstDayColumn;
        for (let i = 0; i < emptyCellsCount; i++) {
          daysWithEmptyCells.push({ day: null, isEmpty: true });
        }
      }

      daysInWeek.forEach((day) => {
        daysWithEmptyCells.push({ day, isEmpty: false });
      });

      weeks.push(daysWithEmptyCells);
      currentDay = addDays(currentDay, 7);
    }

    return weeks;
  }

  const calendarDays = () =>
    getMonthDaysByWeeks().map((d, i) => {
      return (
        <TableRow key={i}>
          {d.map((days, i) => {
            return (
              <StyledTableCell key={i}>
                {
                  <>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      marginBottom={2}
                    >
                      <Typography variant="body1" fontWeight="700">
                        {days.isEmpty
                          ? ""
                          : format(days.day ?? new Date(), "d")}
                      </Typography>
                      <StyledRepeatIcon />
                    </Box>
                    <Box
                      sx={{ maxHeight: 104, minHeight: 104, overflowY: "auto" }}
                    >
                      <CalendarIntervals />
                      <CalendarIntervals />
                    </Box>
                  </>
                }
              </StyledTableCell>
            );
          })}
        </TableRow>
      );
    });
  return (
    <Box sx={{ width: "100%", marginTop: 4 }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {daysOfWeek.map((column) => (
                <TableCell
                  sx={{ backgroundColor: "#fff" }}
                  key={column}
                  align={"center"}
                >
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{calendarDays()}</TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CalendarView;
